import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { FormInput, FormSelect } from '../components/FormControls.jsx';

export function SuperAdminOrganizationsPage() {
  const [searchParams] = useSearchParams();
  const [orgs, setOrgs] = useState({ data: [] });
  const [plans, setPlans] = useState([]);
  const [search, setSearch] = useState(() => searchParams.get('search') || '');
  const [loading, setLoading] = useState(true);

  const load = () => {
    const params = new URLSearchParams();
    if (search) {
      params.set('search', search);
    }
    setLoading(true);
    apiJson(`/api/super-admin/organizations?${params}`)
      .then(setOrgs)
      .catch(() => setOrgs({ data: [] }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const fromUrl = searchParams.get('search');
    if (fromUrl != null) {
      setSearch(fromUrl);
    }
    const params = new URLSearchParams();
    if (fromUrl) {
      params.set('search', fromUrl);
    }
    setLoading(true);
    apiJson(`/api/super-admin/organizations?${params}`)
      .then(setOrgs)
      .catch(() => setOrgs({ data: [] }))
      .finally(() => setLoading(false));
    apiJson('/api/super-admin/plans')
      .then(setPlans)
      .catch(() => setPlans([]));
  }, [searchParams]);

  const toggleSuspend = async (org) => {
    await apiJson(`/api/super-admin/organizations/${org.id}`, {
      method: 'PUT',
      body: { is_suspended: !org.is_suspended },
    });
    load();
  };

  const extendTrial = async (org) => {
    await apiJson(`/api/super-admin/organizations/${org.id}/extend-trial`, {
      method: 'POST',
      body: { days: 14 },
    });
    load();
  };

  const changePlan = async (org, planId) => {
    const currentPlanId = org.subscription?.plan?.id;
    if (!planId || String(planId) === String(currentPlanId ?? '')) {
      return;
    }
    await apiJson(`/api/super-admin/organizations/${org.id}/change-plan`, {
      method: 'POST',
      body: { plan_id: Number(planId) },
    });
    load();
  };

  const rows = orgs.data || [];

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Organizations</h2>
      <div className="row-actions" style={{ marginBottom: '1rem' }}>
        <FormInput
          placeholder="Search by name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: 240 }}
        />
        <button type="button" className="btn-secondary" onClick={() => load()}>
          Search
        </button>
      </div>
      {loading ? <p className="muted">Loading…</p> : null}
      <div className="table-wrap" data-tour="orgs-list">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Owner</th>
              <th>Clients</th>
              <th>Plan</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((o) => (
              <tr key={o.id}>
                <td>{o.name}</td>
                <td>{o.owner?.email || '—'}</td>
                <td>{o.clients_count ?? '—'}</td>
                <td>
                  <FormSelect
                    value={o.subscription?.plan?.id ?? ''}
                    onChange={(e) => void changePlan(o, e.target.value)}
                    aria-label={`Plan for ${o.name}`}
                    style={{ maxWidth: '11rem' }}
                  >
                    <option value="">—</option>
                    {plans.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </FormSelect>
                </td>
                <td>
                  {o.is_suspended ? 'suspended' : o.subscription?.status || '—'}
                </td>
                <td className="row-actions">
                  <button type="button" className="btn-link" onClick={() => void toggleSuspend(o)}>
                    {o.is_suspended ? 'Unsuspend' : 'Suspend'}
                  </button>
                  <button type="button" className="btn-link" onClick={() => void extendTrial(o)}>
                    +14d trial
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
